module.exports = __webpack_public_path__ + "static/media/button-refresh-2.326774b0.svg";